import React from "react";
import internalStateService from "../app/InternalStateService";
import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";

export function resolve(json, options = {}) {
    if (!json) {
        // Add debug module
        WEBUILogs.warn("Warning: resolving without passing data!");
        return;
    }
    //This should not be possible
    if (!json.type) {
        WEBUILogs.error("WARNING: The provided component type is undefined!");
    } else {
        if (Array.isArray(json)) {
            return createMultipleComponentFromJSON(json, options);
        } else {
            return createComponentFromJSON(json, options);
        }
    }
}
export function createMultipleComponentFromJSON(components, options) {
    var res = [];

    components.forEach(function(component, idx) {
        res.push(resolve(component, options));
    });
    return res;
}
export function createComponentFromJSON(component, options) {
    var mappedComponent;

    if (!component) {
        // Add debug module
        WEBUILogs.warn("Warning: component creation without passing metadata!");
        return;
    }
    mappedComponent = internalStateService.getComponent(component.type, { widgetId: options.widgetId });
    if (!mappedComponent) {
        WEBUILogs.error("Missing component: " + component.type);
        //rendering "base" component if component type is unrecognised
        mappedComponent = internalStateService.getComponent("base");
    }

    var reactElement = React.createElement(
        mappedComponent,
        Object.assign(
            {},
            {
                config: component
            },
            options
        )
    );

    return reactElement;
}
